import BaseIpcRouter, { type BaseIpcRouterType, type PreferredHourCycle } from '@shared/ipc/routers/BaseIpc.router'
import type { OpenDialogReturnValue, OpenDialogOptions } from 'electron'

class BaseIpcRenderer extends BaseIpcRouter implements BaseIpcRouterType {
  async getPreferredHourCycle(): Promise<PreferredHourCycle | null> {
    return this.exec('getPreferredHourCycle')
  }

  async updateOpenAtLogin(openAtLogin: boolean): Promise<void> {
    return this.exec('updateOpenAtLogin', openAtLogin)
  }

  async restartApp(): Promise<void> {
    return this.exec('restartApp')
  }

  async refreshCalendarEvents(): Promise<void> {
    return this.exec('refreshCalendarEvents')
  }

  async showOpenDialog(options?: OpenDialogOptions): Promise<OpenDialogReturnValue> {
    return this.exec('showOpenDialog', options)
  }

  async getFileIcon(filePath: string): Promise<string> {
    return this.exec('getFileIcon', filePath)
  }
}

export default new BaseIpcRenderer()
